import { render, staticRenderFns } from "./ResidentialLandForSale.vue?vue&type=template&id=c9672c26&"
import script from "./ResidentialLandForSale.vue?vue&type=script&lang=ts&"
export * from "./ResidentialLandForSale.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports